<span class="counter-num" [ngClass]="fromDetails">
  {{msgCount}}
</span>
